<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">ตั้งค่าบัญชีธนาคาร</h6>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-12">
          <card header-classes="bg-transparent">
            <template v-slot:header>
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="h3 mb-0">ข้อมูลบัญชีสำหรับรับโอน</h5>
                </div>
              </div>
            </template>
            <div class="row text-center">
              <div class="col-12 col-md-4"></div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label class="font-weight-bold">ธนาคาร</label>
                  <select v-model="bankName" class="form-control">
                    <option value="">กรุณาเลือกธนาคาร</option>
                    <option v-for="bank in BANK_LIST" :key="bank" :value="bank">
                      {{ bank }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="font-weight-bold">เลขบัญชี</label>
                  <input
                    v-model="accountNumber"
                    class="form-control"
                    type="text"
                    inputmode="numeric"
                    maxlength="20"
                    placeholder="กรอกเลขบัญชี"
                  />
                </div>
                <div class="form-group">
                  <label class="font-weight-bold">ชื่อบัญชี</label>
                  <input
                    v-model="accountName"
                    class="form-control"
                    type="text"
                    maxlength="120"
                    placeholder="กรอกชื่อบัญชี"
                  />
                </div>
                <button class="btn btn-primary" @click="submitBankSetting">
                  ยืนยัน
                </button>
              </div>
              <div class="col-12 col-md-4"></div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import axios from "../services/axios";

const BANK_LIST = [
  "ธนาคารกรุงเทพ",
  "ธนาคารกสิกรไทย",
  "ธนาคารกรุงไทย",
  "ธนาคารทหารไทย",
  "ธนาคารไทยพาณิชย์",
  "ธนาคารกรุงศรีอยุธยา",
  "ธนาคารเกียรตินาคิน",
  "ธนาคารซีไอเอ็มบีไทย",
  "ธนาคารทิสโก้",
  "ธนาคารธนชาต",
  "ธนาคารยูโอบี",
  "ธนาคารออมสิน",
  "ธนาคารอาคารสงเคราะห์",
];

const toast = useToast();

export default {
  name: "BankSettingPage",
  components: {},
  data() {
    return {
      BANK_LIST,
      bankName: "",
      accountNumber: "",
      accountName: "",
    };
  },
  created() {
    if (!this.IsLoggedIn) {
      this.$router.push("/login");
    } else {
      this.fetchBankSetting();
    }
  },
  methods: {
    fetchBankSetting() {
      axios
        .get("/admin/payment")
        .then((resp) => {
          if (
            resp?.data?.status === "success" &&
            resp?.data?.data?.length > 0
          ) {
            const bankData = resp.data.data[0];
            this.bankName = bankData.bank || "";
            this.accountNumber = bankData.number || "";
            this.accountName = bankData.name || "";
          }
        })
        .catch((err) => {
          if (err?.response) {
            if (
              err?.response?.status !== 401 &&
              err?.response?.status !== 403
            ) {
              toast.error(
                err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "ไม่สามารถโหลดข้อมูลบัญชีได้"
              );
            }
          }
        });
    },
    submitBankSetting() {
      if (!this.bankName) {
        toast.error("กรุณาเลือกธนาคาร");
        return;
      }

      if (!this.accountNumber) {
        toast.error("กรุณากรอกเลขบัญชี");
        return;
      }

      if (!/^\d+$/.test(this.accountNumber)) {
        toast.error("เลขบัญชีต้องเป็นตัวเลขเท่านั้น");
        return;
      }

      if (!this.accountName) {
        toast.error("กรุณากรอกชื่อบัญชี");
        return;
      }

      axios
        .post(
          "/admin/payment",
          {
            bank: this.bankName,
            number: this.accountNumber,
            name: this.accountName,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("AUTH"),
            },
          }
        )
        .then((resp) => {
          if (resp?.data?.status === "success") {
            toast.success("บันทึกบัญชีธนาคารสำเร็จ");
            this.fetchBankSetting();
          }
        })
        .catch((err) => {
          if (err?.response) {
            if (
              err?.response?.status !== 401 &&
              err?.response?.status !== 403
            ) {
              toast.error(
                err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "ไม่สามารถบันทึกข้อมูลได้"
              );
            } else {
              this.$store.dispatch("logoutAuth");
              localStorage.removeItem("AUTH");
              this.$router.push("/login");
            }
          }
        });
    },
  },
  computed: {
    ...mapGetters(["IsLoggedIn"]),
  },
};
</script>

<style></style>
